import classNames from 'classnames'
import { FLOOR_OPTION_KEYS } from 'components/createAd/createAdFlowState'
import { useTranslation } from 'react-i18next'

interface FloorSelectProps {
  floor: string
  floorCustom: string
  onFloorChange: (value: string) => void
  onFloorCustomChange: (value: string) => void
  idPrefix?: string
  selectClassName?: string
  hideCustom?: boolean
}

export const FloorCustomInput = ({
  floorCustom,
  onFloorCustomChange,
  idPrefix = 'floor',
}: Pick<FloorSelectProps, 'floorCustom' | 'onFloorCustomChange' | 'idPrefix'>) => {
  const { t } = useTranslation()
  const customId = `${idPrefix}-custom`

  return (
    <div>
      <label htmlFor={customId} className="mb-1.5 block text-sm font-semibold text-gray-800">
        {t('createAd.flow.fields.floorCustom')}
      </label>
      <input
        id={customId}
        inputMode="numeric"
        value={floorCustom}
        onChange={e => onFloorCustomChange(e.target.value.replace(/\D/g, ''))}
        placeholder={t('createAd.flow.placeholders.floorCustom')}
        className="w-full rounded-xl border border-gray-200 py-3 px-4 focus:outline-none focus:ring-0"
      />
    </div>
  )
}

const FloorSelect = ({
  floor,
  floorCustom,
  onFloorChange,
  onFloorCustomChange,
  idPrefix = 'floor',
  selectClassName,
  hideCustom = false,
}: FloorSelectProps) => {
  const { t } = useTranslation()
  const selectId = `${idPrefix}-select`

  return (
    <div className={hideCustom ? undefined : 'space-y-3'}>
      <div>
        <label htmlFor={selectId} className="mb-1.5 block text-sm font-semibold text-gray-800">
          {t('createAd.flow.fields.floor')}
        </label>
        <div className="relative">
          <select
            id={selectId}
            value={floor}
            onChange={e => {
              const next = e.target.value
              onFloorChange(next)
              if (next !== '5_plus') {
                onFloorCustomChange('')
              }
            }}
            className={classNames(
              'w-full appearance-none rounded-xl border border-gray-200 bg-white py-3 pl-4 pr-10 text-sm text-gray-900 focus:outline-none focus:ring-0',
              selectClassName
            )}
          >
            <option value="">{t('createAd.flow.placeholders.select')}</option>
            {FLOOR_OPTION_KEYS.map(key => (
              <option key={key} value={key}>
                {t(`createAd.flow.floorOptions.${key}`)}
              </option>
            ))}
          </select>
          <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </span>
        </div>
      </div>
      {!hideCustom && floor === '5_plus' ? (
        <FloorCustomInput
          idPrefix={idPrefix}
          floorCustom={floorCustom}
          onFloorCustomChange={onFloorCustomChange}
        />
      ) : null}
    </div>
  )
}

export default FloorSelect
